// src/routes/AppRoutes.js
import { createBrowserRouter, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { lazy } from 'react';
import ResetPasswordPage from '../views/Authentication/ResetPasswordPage';

// project imports
import Loadable from '../ui-component/Load';
import MainLayout from '../layout/MainLayout';
import { Outlet } from 'react-router';
import TodoList from '../views/pages/TodoList';
import FileDisplay from '../views/pages/FileDisplay';
import NotFound from "../ui-component/NotFound";
const Login = Loadable(lazy(() => import('../views/Authentication/Login')));
const Register = Loadable(lazy(() => import('../views/Authentication/Register')));
const ForgotPassword = Loadable(lazy(() => import('../views/Authentication/ForgotPassword')));
const Dashboard = Loadable(lazy(() => import('../views/pages/Dashboard')));
const CaseMangement = Loadable(lazy(() => import('../views/pages/CaseMagement')));
const ClientManagement = Loadable(lazy(() => import('../views/pages/ClientManagement')));
const AddClients = Loadable(lazy(() => import('../views/pages/AddClients')));
const AddCase = Loadable(lazy(() => import('../views/pages/AddCase')));
const AddLawer = Loadable(lazy(() => import('../views/pages/AddLawyers')));
const ListAllLawyers = Loadable(lazy(() => import('../views/pages/Lawyers')));
const AddHearing = Loadable(lazy(() => import('../views/pages/AddHearing')));
const OpenHearing = Loadable(lazy(() => import('../views/pages/Hearings')));
const CaseDetail = Loadable(lazy(() => import('../views/pages/CaseDetail')));
const Profile = Loadable(lazy(() => import('../views/pages/Profile')));
const Documents = Loadable(lazy(() => import('../views/pages/Documents')));
const AddDocuments = Loadable(lazy(() => import('../views/pages/AddDocuments')));
const MyCalendar = Loadable(lazy(() => import('../views/pages/MyCalendar')));
const AddTodo = Loadable(lazy(() => import('../views/pages/AddTodo')));
const Admin = Loadable(lazy(() => import('../views/pages/Admin')));

const router = createBrowserRouter([
  {
    element: <PrivateRoute />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        children: [
          {
            path: 'admin',
            element: <Admin />
          },
          {
            path: '/',
            element: <Dashboard />
          },
          {
            path: 'profile',
            element: <Profile />
          },
          {
            path: 'mycalendar',
            element: <MyCalendar />
          },
          {
            path: 'case-management',
            element: <Outlet />,
            children: [
              {
                path: 'add',
                element: <AddCase />
              },
              {
                path: 'add/:caseID',
                element: <AddCase />
              },
              {
                path: 'case/:caseType',
                element: <CaseMangement />
              },
              {
                path: 'caseDetail/:caseID',
                element: <CaseDetail />
              }
            ]
          },
          {
            path: 'lawyer',
            element: <Outlet />,
            children: [
              {
                path: 'add',
                element: <AddLawer />
              },
              {
                path: 'list',
                element: <ListAllLawyers />
              }
            ]
          },
          {
            path: '/client-management',
            element: <Outlet />,
            children: [
              {
                path: 'clients/:clientType',
                element: <ClientManagement />
              },
              {
                path: 'add',
                element: <AddClients />
              },
              {
                path: 'edit/:clientID',
                element: <AddClients />
              }
            ],

          },
          {
            path: '/hearing',
            element: <Outlet />,
            children: [
              {
                path: 'add',
                element: <AddHearing />
              },
              {
                path: ':hearingType',
                element: <OpenHearing />
              }

            ],

          },
          {
            path: '/documents',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <FileDisplay />
              },
              {
                path: 'add',
                element: <AddDocuments />
              }
            ]
          },
          {
            path: '/todo',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <AddTodo />
              },
              {
                path: 'view',
                element: <TodoList />
              }
            ]
          }
        ],
      },
    ],
  },
  {
    path: '/auth/login',
    element: <Login />
  },
  {
    path: '/auth/register',
    element: <Register />
  },
  {
    path: '/auth/register/:token',
    element: <Register />
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPassword />
  },
  {
    path: '/auth/reset-password/',
    element: <ResetPasswordPage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
